import { Injectable } from '@angular/core';
import { BoxxImageModel } from '../models/BoxxImage.model';
import { BoxxImageUtils } from '../utils/imageUtils';
import { BoxxImagePickerTemplateMethod } from './ImagePickerTemplateMethod';

@Injectable()
export class BoxxImagePickerMobileCamera extends BoxxImagePickerTemplateMethod {
  constructor(
    private boxxImageUtils: BoxxImageUtils
  ) {
    super();
  }

  setPickerOptions(options: any) {
    this.pickerOptions = options;
    return this;
  }

  getSourceImages(): Promise<BoxxImageModel[]> {
    const response: BoxxImageModel[] = [];
    const options = {
      ...this.pickerOptions,
      destinationType: 1, //0=DATA_URL, 1=FILE_URI, 2=NATIVE_URI
    } as any;
    return null;
    // return this.cameraNativeService.openCameraMedia('camera', options).then(
    //   async path => {
    //     if (!path) {
    //       return response;
    //     }

    //     const content = await this.boxxImageUtils.imgDataUriToBase64(path);
    //     const bytes = await this.boxxImageUtils.getImgFileSize(content);
    //     const dimensions = await this.boxxImageUtils.getImgDimensions(content);

    //     response.push(
    //       new BoxxImageModel({
    //         bytes,
    //         dimensions,
    //         content,
    //         path,
    //       })
    //     );

    //     return response;
    //   },
    //   error => {
    //     throw error;
    //   }
    // );
  }
}
